import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-[#1a1a1a] selection:bg-[#c06a2b] selection:text-white" data-id="element-1">
        <Navbar data-id="element-2" />

        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
        </Routes>

        <Footer data-id="element-8" />
      </div>
    </BrowserRouter>;
}